export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const TREE_LIST = 'TREE_LIST';
export const MENU_LIST = 'MENU_LIST';
export const SELECTED_MENU = 'SELECTED_MENU';

export default {
	DEFAULT_ASSIGN,
	SEARCH_PARAM,
	TREE_LIST,
	MENU_LIST,
	SELECTED_MENU
};
